import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";


const JavaScriptLesson20 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3>JavaScript Primitives</h3>
   <p>A primitive value is one that has no properties of methods.</p>
   <p>A primitive data type is one that has a primitive value.</p>
   <p>JavaScript has the following primitive data types:</p>
    <ol class="list-group list-group-numbered mb-4">
     <li class="list-group-item">String</li>
     <li class="list-group-item">Number</li>
     <li class="list-group-item">Boolean</li>
     <li class="list-group-item">Undefined</li>
     <li class="list-group-item">Null</li>
   </ol>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson20
